<template>
    <div class="adminOpinions" v-if="!loading">
        <data-table
            v-if="!loading && data.data.length"
            :items="data.data"
            :fields="fields"
        >
            <template v-slot:positive="row">
                <span v-if="row.value" class="text-success"><i class="fa fa-thumbs-up"></i></span>
                <span v-else class="text-danger"><i class="fa fa-thumbs-down"></i></span>
            </template>
            <template v-slot:client="row">
                <client :client="row.value" withAvatar/>
            </template>
            <template v-slot:created_at="row">
                {{ row.value | moment("DD-MM-YYYY HH:mm")}}
            </template>
        </data-table>
        
        <admin-opinion
            :dbid="dbid"
            :add="data.add"
            :pos="count(true)"
            :neg="count(false)"
            v-on:added="loadData"
        />
    </div>
</template>

<script>
import AdminOpinion from "@/components/AdminOpinion";
import AdminOpinionsService from "@/services/admin-opinions.service"

export default {
    name: "AdminOpinions",
    props: {
        dbid: String
    },
    components: {AdminOpinion},
    data() {
        return {
            fields: [
                {key: "positive", label: "Ocena", sortable: true},
                {key: "content", label: "Zawartość"},
                {key: "client", label: "Klient"},
                {key: "created_at", label: "Utworzona"}
            ],
            loading: true,
            data: []
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;
            
            AdminOpinionsService.getAdmin(this.dbid).then(
                response => {
                    this.data = response.data;
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        count(positive) {
            let result = this.data.data.filter(o => o.positive == positive);
            return result.length;
        }
    }
}
</script>

<style scoped>
</style>